import { render } from "./submission-company-panel.vue?vue&type=template&id=38b6f08e&scoped=true&ts=true"
import script from "./submission-company-panel.vue?vue&type=script&lang=ts"
export * from "./submission-company-panel.vue?vue&type=script&lang=ts"

import "./submission-company-panel.vue?vue&type=style&index=0&id=38b6f08e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b6f08e"]])

export default __exports__